import { FC, useEffect, useRef, useState } from 'react';

import {
  DeleteOutlined,
  EditOutlined,
  EllipsisOutlined,
} from '@ant-design/icons';
import { Button, Popconfirm, Popover } from 'antd';

import {
  deleteTag,
  updateTag,
} from '../../../../../app/providers/redux/slices/reports/params/reports/reportsSlice';
import { ROLES } from '../../../../../helpers/utils/auth';
import { showErrorMessage } from '../../../../../helpers/utils/ui';
import { useAppDispatch, useTypedSelector } from '../../../hooks/useTypedSelector';
import styles from '../styles/SideMenu.module.scss';
import { TabType } from '../types';

type Props = {
  tag: { id: number; name: string; is_shared?: boolean };
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
};
const modalButtonStyle = {
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  padding: '4px 8px',
  display: 'flex',
  alignItems: 'center',
  transition: 'background 0.3s',
  ':hover': {
    color: 'blue',
  },
};


const SuperPermission = new Set([ ROLES.super, ROLES.owner, ROLES.employee ]);

export const Tag: FC<Props> = ({ tag, activeTab, setActiveTab }) => {

  const currentUserRole = useTypedSelector(state => state.currentUser.role);
  const [ isVisible, setIsVisivle ] = useState(false);
  const [ isVisibleMenu, setIsVisivleMenu ] = useState(false);
  const [ renameOpen, setRenameOpen ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const dispatch = useAppDispatch();

  const canEditTag = SuperPermission.has(currentUserRole);
  const isDisable = currentUserRole !== ROLES.super && tag.is_shared;

  useEffect(() => {
    if (renameOpen) {
      inputRef.current?.focus();
    }
  }, [ renameOpen ]);

  const handleTagClick = (tagId: number) => {
    setActiveTab(tagId);
  };

  const handleDeleteTag = async () => {
    try {
      setLoading(true);
      await dispatch(deleteTag(tag.id)).unwrap();
      setIsVisivle(false);
    } catch (error) {
      showErrorMessage('Ошибка удаления тега');
    } finally {
      setLoading(false);
    }
  };

  const handleRenameTag = async () => {
    if (!inputRef || !inputRef.current) return;

    const newName = inputRef.current.value;

    if (!newName.trim()) {
      showErrorMessage('Название тега не может быть пустым');
      return;
    }

    try {
      setLoading(true);
      await dispatch(updateTag({ tagId: tag.id, tagName: newName })).unwrap();
      setIsVisivle(false);
      setRenameOpen(false);
    } catch (error) {
      showErrorMessage('Ошибка переименования тега');
    } finally {
      setLoading(false);
    }
  };

  const PopoverContent = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      {renameOpen ? (
        <div style={{ display: 'flex', gap: '8px' }}>
          <input
            type="text"
            style={{ padding: '4px', flex: 1 }}
            ref={inputRef}
            defaultValue={tag.name}
          />
          <Button
            onClick={handleRenameTag}
            style={{ padding: '0 8px' }}
            loading={loading}
          >
            Сохранить
          </Button>
          <Button
            onClick={() => setRenameOpen(false)}
            style={{ padding: '0 8px' }}
          >
            Отмена
          </Button>
        </div>
      ) : (
        <Button style={modalButtonStyle} onClick={() => setRenameOpen(true)}>
          <EditOutlined style={{ fontSize: 15, marginRight: '8px' }} />
          <span style={{ fontSize: 15 }}>Переименовать</span>
        </Button>
      )}
      <Popconfirm
        title="Вы уверены, что хотите удалить этот тег?"
        onConfirm={handleDeleteTag}
        okText="Удалить"
        cancelText="Отмена"
        okButtonProps={{ loading }}
      >
        <Button style={modalButtonStyle} loading={loading} disabled={loading}>
          <DeleteOutlined style={{ fontSize: 15, marginRight: '8px' }} />
          <span style={{ fontSize: 15 }}>Удалить</span>
        </Button>
      </Popconfirm>
    </div>
  );

  return (
    <div
      key={tag.id}
      className={`${styles['menu-item']} ${
        activeTab === tag.id ? styles['active'] : ''
      }`}
      onClick={() => handleTagClick(tag.id)}
      style={{ display: 'flex', justifyContent: 'space-between' }}
      onMouseEnter={() => setIsVisivleMenu(true)}
      onMouseLeave={() => setIsVisivleMenu(false)}
    >
      {tag.name}

      {
        <div
          style={{
            cursor: 'pointer',
            padding: '0px',
            marginRight: '5px',
            visibility: isVisibleMenu ? 'visible' : 'hidden',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {canEditTag && !isDisable && <Popover
            content={PopoverContent}
            trigger="click"
            // placement="bottom"
            overlayClassName={styles['popover-overlay']}
            open={isVisible}
            onOpenChange={(visible) => {
              setIsVisivle(visible);
            }}
          >
            <EllipsisOutlined
              style={{
                fontSize: 16,
                padding: 0,
                margin: 0,
              }}
            />
          </Popover>}
        </div>
      }
    </div>
  );
};
